export interface CountryCode {
    code: string
    country: string
    dialCode: string
}

export const countryCodes: CountryCode[] = [
    { code: 'US', country: 'United States', dialCode: '+1' },
    { code: 'CA', country: 'Canada', dialCode: '+1' },
    { code: 'GB', country: 'United Kingdom', dialCode: '+44' },
    { code: 'AU', country: 'Australia', dialCode: '+61' },
    { code: 'DE', country: 'Germany', dialCode: '+49' },
    { code: 'FR', country: 'France', dialCode: '+33' },
    { code: 'IT', country: 'Italy', dialCode: '+39' },
    { code: 'ES', country: 'Spain', dialCode: '+34' },
    { code: 'NL', country: 'Netherlands', dialCode: '+31' },
    { code: 'BE', country: 'Belgium', dialCode: '+32' },
    { code: 'CH', country: 'Switzerland', dialCode: '+41' },
    { code: 'AT', country: 'Austria', dialCode: '+43' },
    { code: 'SE', country: 'Sweden', dialCode: '+46' },
    { code: 'NO', country: 'Norway', dialCode: '+47' },
    { code: 'DK', country: 'Denmark', dialCode: '+45' },
    { code: 'FI', country: 'Finland', dialCode: '+358' },
    { code: 'PL', country: 'Poland', dialCode: '+48' },
    { code: 'IE', country: 'Ireland', dialCode: '+353' },
    { code: 'PT', country: 'Portugal', dialCode: '+351' },
    { code: 'GR', country: 'Greece', dialCode: '+30' },
    { code: 'CZ', country: 'Czech Republic', dialCode: '+420' },
    { code: 'HU', country: 'Hungary', dialCode: '+36' },
    { code: 'RO', country: 'Romania', dialCode: '+40' },
    { code: 'BG', country: 'Bulgaria', dialCode: '+359' },
    { code: 'HR', country: 'Croatia', dialCode: '+385' },
    { code: 'SK', country: 'Slovakia', dialCode: '+421' },
    { code: 'SI', country: 'Slovenia', dialCode: '+386' },
    { code: 'EE', country: 'Estonia', dialCode: '+372' },
    { code: 'LV', country: 'Latvia', dialCode: '+371' },
    { code: 'LT', country: 'Lithuania', dialCode: '+370' },
    { code: 'JP', country: 'Japan', dialCode: '+81' },
    { code: 'CN', country: 'China', dialCode: '+86' },
    { code: 'KR', country: 'South Korea', dialCode: '+82' },
    { code: 'IN', country: 'India', dialCode: '+91' },
    { code: 'SG', country: 'Singapore', dialCode: '+65' },
    { code: 'MY', country: 'Malaysia', dialCode: '+60' },
    { code: 'TH', country: 'Thailand', dialCode: '+66' },
    { code: 'PH', country: 'Philippines', dialCode: '+63' },
    { code: 'ID', country: 'Indonesia', dialCode: '+62' },
    { code: 'VN', country: 'Vietnam', dialCode: '+84' },
    { code: 'NZ', country: 'New Zealand', dialCode: '+64' },
    { code: 'ZA', country: 'South Africa', dialCode: '+27' },
    { code: 'EG', country: 'Egypt', dialCode: '+20' },
    { code: 'NG', country: 'Nigeria', dialCode: '+234' },
    { code: 'KE', country: 'Kenya', dialCode: '+254' },
    { code: 'MA', country: 'Morocco', dialCode: '+212' },
    { code: 'AR', country: 'Argentina', dialCode: '+54' },
    { code: 'BR', country: 'Brazil', dialCode: '+55' },
    { code: 'MX', country: 'Mexico', dialCode: '+52' },
    { code: 'CO', country: 'Colombia', dialCode: '+57' },
    { code: 'CL', country: 'Chile', dialCode: '+56' },
    { code: 'PE', country: 'Peru', dialCode: '+51' },
    { code: 'VE', country: 'Venezuela', dialCode: '+58' },
    { code: 'EC', country: 'Ecuador', dialCode: '+593' },
    { code: 'BO', country: 'Bolivia', dialCode: '+591' },
    { code: 'PY', country: 'Paraguay', dialCode: '+595' },
    { code: 'UY', country: 'Uruguay', dialCode: '+598' },
    { code: 'CR', country: 'Costa Rica', dialCode: '+506' },
    { code: 'PA', country: 'Panama', dialCode: '+507' },
    { code: 'GT', country: 'Guatemala', dialCode: '+502' },
    { code: 'HN', country: 'Honduras', dialCode: '+504' },
    { code: 'NI', country: 'Nicaragua', dialCode: '+505' },
    { code: 'SV', country: 'El Salvador', dialCode: '+503' },
    { code: 'DO', country: 'Dominican Republic', dialCode: '+1' },
    { code: 'CU', country: 'Cuba', dialCode: '+53' },
    { code: 'JM', country: 'Jamaica', dialCode: '+1' },
    { code: 'TT', country: 'Trinidad and Tobago', dialCode: '+1' },
    { code: 'RU', country: 'Russia', dialCode: '+7' },
    { code: 'UA', country: 'Ukraine', dialCode: '+380' },
    { code: 'BY', country: 'Belarus', dialCode: '+375' },
    { code: 'KZ', country: 'Kazakhstan', dialCode: '+7' },
    { code: 'UZ', country: 'Uzbekistan', dialCode: '+998' },
    { code: 'SA', country: 'Saudi Arabia', dialCode: '+966' },
    { code: 'AE', country: 'United Arab Emirates', dialCode: '+971' },
    { code: 'IL', country: 'Israel', dialCode: '+972' },
    { code: 'TR', country: 'Turkey', dialCode: '+90' },
    { code: 'IR', country: 'Iran', dialCode: '+98' },
    { code: 'IQ', country: 'Iraq', dialCode: '+964' },
    { code: 'JO', country: 'Jordan', dialCode: '+962' },
    { code: 'LB', country: 'Lebanon', dialCode: '+961' },
    { code: 'KW', country: 'Kuwait', dialCode: '+965' },
    { code: 'QA', country: 'Qatar', dialCode: '+974' },
    { code: 'BH', country: 'Bahrain', dialCode: '+973' },
    { code: 'OM', country: 'Oman', dialCode: '+968' },
    { code: 'YE', country: 'Yemen', dialCode: '+967' },
    { code: 'PK', country: 'Pakistan', dialCode: '+92' },
    { code: 'BD', country: 'Bangladesh', dialCode: '+880' },
    { code: 'LK', country: 'Sri Lanka', dialCode: '+94' },
    { code: 'NP', country: 'Nepal', dialCode: '+977' },
    { code: 'MM', country: 'Myanmar', dialCode: '+95' },
    { code: 'KH', country: 'Cambodia', dialCode: '+855' },
    { code: 'LA', country: 'Laos', dialCode: '+856' },
    { code: 'BN', country: 'Brunei', dialCode: '+673' },
    { code: 'TW', country: 'Taiwan', dialCode: '+886' },
    { code: 'HK', country: 'Hong Kong', dialCode: '+852' },
    { code: 'MO', country: 'Macau', dialCode: '+853' },
]

// Sort by country name for easier selection
export const sortedCountryCodes = [...countryCodes].sort((a, b) => 
    a.country.localeCompare(b.country)
)
